var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Component, Vue, Model, Prop } from 'vue-property-decorator';
import { Student } from '@/models/Student';
import { Project } from '@/models/Project';
import { TargetType } from '@/models/Media';
import MediaComponent from '@/components/Media/Media';
let Media = class Media extends Vue {
    // #region @Refs
    // #endregion
    // #region Class properties
    // #endregion
    // #region Lifecycle Hooks / Init
    // #endregion
    // #region Class methods
    // #endregion
    // #region Async methods
    // #endregion
    // #region Getters & Setters
    get mediaFilters() {
        return {
            target: {
                id: this.project.id || '',
                type: TargetType.PROJECT,
            },
        };
    }
};
__decorate([
    Model('student', { default: () => new Student() }),
    __metadata("design:type", typeof (_a = typeof Student !== "undefined" && Student) === "function" ? _a : Object)
], Media.prototype, "student", void 0);
__decorate([
    Prop(),
    __metadata("design:type", typeof (_b = typeof Project !== "undefined" && Project) === "function" ? _b : Object)
], Media.prototype, "project", void 0);
Media = __decorate([
    Component({
        components: {
            MediaComponent,
        },
    })
], Media);
export default Media;
